module.exports = __webpack_public_path__ + "static/img/icon-pdf.dccfc6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/icon-pdf.png
// module id = iBVf
// module chunks = 36